<template>
    <div>
        <div class="app-title">
            <em-view-title ref="viewTitle" :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                           :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                           :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"
                                           @showEntityMultipleModalSelect="$_emCommonModalMixin_showMultipleSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="ppeInventoryResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                      :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                      :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                      ref="emTable" import-enabled :inlineActionsDisabled="prop_inline!=='1'"
                                      with-custom-row-actions-first-column ignore-delete
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #left-header>
                                    <!--                                    <em-button-->
                                    <!--                                        type="gotoChild"-->
                                    <!--                                        custom-icon="fa fa-sign-in"-->
                                    <!--                                        class="btn btn-outline-primary btn-sm"-->
                                    <!--                                        :disabled="actionDisabled('selectOne')"-->
                                    <!--                                        show-name custom-label="备件入库"-->
                                    <!--                                        @click="openBatchInputDialog()">-->
                                    <!--                                    </em-button>-->
                                    <em-button
                                        type="gotoChild"
                                        custom-icon="fa fa-trash"
                                        class="btn btn-outline-primary btn-sm"
                                        :disabled="actionDisabled('select')"
                                        show-name custom-label="PPE物品报废申请"
                                        @click="openBatchScrapDialog()">
                                    </em-button>
                                    <em-button
                                        type="gotoChild"
                                        custom-icon="fa fa-shopping-cart"
                                        class="btn btn-outline-primary btn-sm"
                                        :disabled="actionDisabled('select')"
                                        show-name custom-label="PPE物品库存变动操作"
                                        @click="openBatchOperateDialog()">
                                    </em-button>

                                </template>
                                <template slot="customRowActionsFirstColumn" slot-scope="customRowScope">
                                    <b-button-group>
                                        <em-button
                                            type="gotoChild"
                                            custom-icon="fa fa-edit"
                                            class="btn btn-outline-primary btn-sm"
                                            show-name custom-label="库存变动"
                                            @click="gotoInventoryChangeRecords(customRowScope.row)">
                                        </em-button>
                                    </b-button-group>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>

        <!-- 批量编辑库存对话框 -->
        <el-dialog :close-on-click-modal='false' append-to-body :visible.sync="batchOperateDialogVisible"
                   title="PPE物品库存变动操作"
                   width="60%">
            <el-card>
                <div>
                    <div style="display: flex; align-items: center; margin-bottom: 20px;">
                        <el-radio v-model="changeType" label="6" border><i class="fa fa-sign-in"> 入 库</i></el-radio>
                        <el-radio v-model="changeType" label="7" border><i class="fa fa-sign-out"> 出 库</i></el-radio>
                        <el-radio v-model="changeType" label="2" border><i class="fa fa-user"> 借 用</i></el-radio>
                        <el-radio v-model="changeType" label="3" border><i class="fa fa-rotate-left"> 归 还</i>
                        </el-radio>
                    </div>
                    <!--                    <span style="font-weight: bold;color: red;">*</span>库存变动类型：-->
                    <!--                    <el-select v-model="changeType" placeholder="请选择" clearable @clear="clearChangeType"-->
                    <!--                               style="margin-bottom: 20px;">-->
                    <!--                        <el-option-->
                    <!--                            v-for="item in options"-->
                    <!--                            :key="item.value"-->
                    <!--                            :label="item.label"-->
                    <!--                            :value="item.value">-->
                    <!--                        </el-option>-->
                    <!--                    </el-select>-->
                </div>
                <el-table :data="selectedBatchOperateData" border stripe>
                    <el-table-column type="text" align="center" width="1"></el-table-column>
                    <el-table-column prop="id" label="ID" align="center" width="50" v-if="false"></el-table-column>
                    <el-table-column prop="itemType" label="物品类别ID" align="center" width="100"
                                     v-if="false"></el-table-column>
                    <el-table-column prop="itemTypeName" label="物品类别" align="center" width="100"></el-table-column>
                    <el-table-column prop="itemName" label="物品名称" align="center" width="200"></el-table-column>
                    <el-table-column prop="itemModel" label="物品型号" align="center" width="200"
                                     v-if="false"></el-table-column>
                    <el-table-column prop="quantity" label="库存数量" align="center" width="100"></el-table-column>
                    <el-table-column prop="itemUnit" label="单位" align="center" width="20"
                                     v-if="false"></el-table-column>
                    <el-table-column prop="changeQuantity" label="变动数量" align="center" width="100">
                        <template slot-scope="scope">
                            <el-input type="number" v-model="scope.row.changeQuantity"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="outputTime" label="变动时间" align="center" width="245">
                        <template slot-scope="scope">
                            <el-date-picker type="datetime" v-model="scope.row.changeTime"
                                            value-format="yyyy-MM-dd HH:mm:ss"
                                            placeholder="默认当前时间"></el-date-picker>
                        </template>
                    </el-table-column>
                    <el-table-column prop="remark" label="备注" align="center">
                        <template slot-scope="scope">
                            <el-input type="text" v-model="scope.row.changeRemark"></el-input>
                        </template>
                    </el-table-column>
                </el-table>
            </el-card>
            <div slot="footer" class="dialog-footer" align="center">
                <el-button icon="el-icon-close" @click="batchOperateDialogVisible = false">取消操作</el-button>&nbsp;&nbsp;
                <el-popconfirm title="确定要执行库存变动操作吗？" @confirm="batchOperate">
                    <el-button type="primary" slot="reference" icon="el-icon-check">确认提交</el-button>
                </el-popconfirm>
            </div>
        </el-dialog>

        <!-- 批量报废对话框 -->
        <el-dialog :close-on-click-modal='false' append-to-body :visible.sync="batchScrapDialogVisible"
                   title="发起PPE物品报废申请"
                   width="60%">
            <el-card>
                <el-table :data="selectedBatchOperateData" border stripe>
                    <el-table-column type="text" align="center" width="1"></el-table-column>
                    <el-table-column prop="id" label="ID" align="center" width="50" v-if="false"></el-table-column>
                    <el-table-column prop="itemType" label="物品类别ID" align="center" width="100"
                                     v-if="false"></el-table-column>
                    <el-table-column prop="itemTypeName" label="物品类别" align="center" width="100"></el-table-column>
                    <el-table-column prop="itemName" label="物品名称" align="center" width="200"></el-table-column>
                    <el-table-column prop="itemModel" label="物品型号" align="center" width="200"
                                     v-if="false"></el-table-column>
                    <el-table-column prop="quantity" label="库存数量" align="center" width="100"></el-table-column>
                    <el-table-column prop="itemUnit" label="单位" align="center" width="20"
                                     v-if="false"></el-table-column>
                    <el-table-column prop="changeQuantity" label="报废数量" align="center" width="100">
                        <template slot-scope="scope">
                            <el-input type="number" v-model="scope.row.changeQuantity"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="outputTime" label="报废时间" align="center" width="245">
                        <template slot-scope="scope">
                            <el-date-picker type="datetime" v-model="scope.row.changeTime"
                                            value-format="yyyy-MM-dd HH:mm:ss"
                                            placeholder="默认当前时间"></el-date-picker>
                        </template>
                    </el-table-column>
                    <el-table-column prop="remark" label="报废原因备注" align="center">
                        <template slot-scope="scope">
                            <el-input type="text" v-model="scope.row.changeRemark"
                                      placeholder="请填写报废原因"></el-input>
                        </template>
                    </el-table-column>
                </el-table>
            </el-card>
            <div slot="footer" class="dialog-footer" align="center">
                <el-button icon="el-icon-close" @click="batchScrapDialogVisible = false">取消操作</el-button>&nbsp;&nbsp;
                <el-popconfirm title="确定要发起PPE物品报废申请吗？" @confirm="batchScrap">
                    <el-button type="primary" slot="reference" icon="el-icon-check">确认提交</el-button>
                </el-popconfirm>
            </div>
        </el-dialog>
    </div>
</template>
<script>
// Author THQ
// Date 2025-03-09 09:58:18

import emCommonListMixin from "@/mixin/em/common/list";
import emCustomVuexMixin from "@/mixin/em/customVuex";
import emApiMixin from "@/mixin/em/common/api";
import emTableCheckedMixin from "@/mixin/em/common/stuffs/table/emTableCheckedMixin";
import emCommonGotoMixin from "@/mixin/em/common/goto";

export default {
    name: "ppeInventoryListView",
    mixins: [emCommonListMixin, emCustomVuexMixin, emApiMixin, emTableCheckedMixin, emCommonGotoMixin],
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    data() {
        return {
            options: [{
                value: '6',
                label: '入库'
            }, {
                value: '7',
                label: '出库'
            }, {
                value: '2',
                label: '借用'
            }, {
                value: '3',
                label: '归还'
            }],
            changeType: null,
            batchOperateDialogVisible: false,
            batchScrapDialogVisible: false,
            selectedBatchOperateData: [],
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        checkedItems() {
            return this.$store.state[this.modelName]["checkedItems"];
        },
        checkedEntity() {
            return this.$store.state[this.modelName]["entity"];
        },

        selectIds() {
            return this.$store.state[this.modelName]["checkedItems"].join(",");
        },
    },
    methods: {
        gotoInventoryChangeRecords(row) {
            this.$_emGotoMixin_gotoHolderList("ppeApplyRecordHistory"
                , {inventoryIdFilter: row.id}
                , {inventoryIdFilter: row.id}, false, {})
        },
        openBatchOperateDialog() {
            this.selectedBatchOperateData = [];
            //填充勾选数据行到selectedBatchOperateData
            this.selectedBatchOperateData = this.checkedRows.map(item => {
                return {
                    id: item.id,
                    itemType: item.itemType,
                    itemTypeName: item.itemTypeName,
                    itemName: item.itemName,
                    itemModel: item.itemModel,
                    quantity: item.quantity,
                    itemUnit: item.itemUnit,
                    changeQuantity: '',
                    changeTime: '',
                    // destination: '',
                    changeRemark: ''
                }
            });
            this.changeType = null;
            this.batchOperateDialogVisible = true;
        },
        openBatchScrapDialog() {
            this.selectedBatchOperateData = [];
            //填充勾选数据行到selectedBatchOperateData
            this.selectedBatchOperateData = this.checkedRows.map(item => {
                return {
                    id: item.id,
                    itemType: item.itemType,
                    itemTypeName: item.itemTypeName,
                    itemName: item.itemName,
                    itemModel: item.itemModel,
                    quantity: item.quantity,
                    itemUnit: item.itemUnit,
                    changeQuantity: '',
                    changeTime: '',
                    // destination: '',
                    changeRemark: ''
                }
            });
            this.batchScrapDialogVisible = true;
        },
        clearChangeType() {
            this.changeType = null;
        },
        batchOperate() {
            // 库存变动类型验证
            if (this.changeType === null) {
                this.$message.error('请选择库存变动类型！');
                return;
            }
            // 库存变动数量验证
            for (let i = 0; i < this.selectedBatchOperateData.length; i++) {
                if (this.selectedBatchOperateData[i].changeQuantity === null ||
                    this.selectedBatchOperateData[i].changeQuantity === '') {
                    this.$message.error('请填写库存变动数量！');
                    return;
                }
                if (this.selectedBatchOperateData[i].changeQuantity <= 0) {
                    this.$message.error('库存变动数量必须大于0！');
                    return;
                }
            }
            // 绑定变动类型
            this.selectedBatchOperateData.forEach(item => {
                item.changeType = this.changeType;
            });

            // console.log(this.selectedBatchOperateData);
            let _self = this;
            let _url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/ppeInventoryChange`
            this.$_emApiMixin_post(_url, this.selectedBatchOperateData)
                .then(() => {
                    this.$message.success('PPE库存变动操作成功！');
                    _self.batchOperateDialogVisible = false;
                    _self.$refs.emListFilter.doQuery();
                });
        },
        batchScrap() {
            // 库存变动数量验证
            for (let i = 0; i < this.selectedBatchOperateData.length; i++) {
                if (this.selectedBatchOperateData[i].changeQuantity === null ||
                    this.selectedBatchOperateData[i].changeQuantity === '') {
                    this.$message.error('请填写物品报废数量！');
                    return;
                }
                if (this.selectedBatchOperateData[i].changeQuantity <= 0) {
                    this.$message.error('报废数量必须大于0！');
                    return;
                }
            }
            // 绑定变动类型 (报废)
            this.selectedBatchOperateData.forEach(item => {
                item.changeType = 4;
            });

            //console.log(this.selectedBatchOperateData)
            let _self = this;
            let _url = `${this.$_emApiMixin_entityBaseApi("ppeApplyScrap")}/batchScrapHandle`
            this.$_emApiMixin_post(_url, this.selectedBatchOperateData)
                .then(() => {
                    this.$message.success('PPE物品报废申请发起成功，请到报废待办继续提交报废审核！');
                    _self.batchScrapDialogVisible = false;
                    //_self.$refs.emListFilter.doQuery();
                    _self.$router.push("/em/ppe/ppeApplyScrapList?pathType=todo");
                });
        }
    }
};
</script>